import { ScheduledQueryRequest } from '@api/api/scheduled-queries';
import { WebSearch } from '@terminal/views/alfred/research/services/conversations-service';

export const storedWebSearchToUIValue = (
  toolsConfig: ScheduledQueryRequest['tools_config']
): WebSearch => {
  if (toolsConfig?.group_filter?.policy === 'Block') {
    return 'block';
  }
  const webSearch = toolsConfig?.parameters?.web_search;
  if (
    webSearch === 'open' ||
    webSearch === 'restricted' ||
    webSearch === 'block'
  ) {
    return webSearch;
  }

  if (
    webSearch &&
    typeof webSearch === 'object' &&
    'sources' in webSearch &&
    Array.isArray(webSearch.sources)
  ) {
    return webSearch.sources.length > 0 ? 'restricted' : 'open';
  }
  return 'open';
};
